import { Button, Label, Loading, Radio } from "@components";
import { useIsInViewport } from "@hooks";
import { StandaloneCouponsAPI } from "providers/StandaloneCouponsAPI";
import { useCallback, useEffect, useRef, useState } from "react";
import { If } from "shared/components/control-statements";
import { InputSearch } from "shared/components/InputSearch";
import styles from "@styles/benefits.module.scss";
import { Benefit } from "shared/core/Benefit";
import classNames from "classnames/bind";
import { Ticket } from "shared/components/Icons";
import { Environment } from "shared/core/Environment";
const css = classNames.bind(styles);

export default function Coupons({ creative, onChangeCreative }) {
  const [loading, setLoading] = useState(false);
  const [benefits, setBenefits] = useState([]);
  const [search, setSearch] = useState("");
  const [hasNext, setHasNext] = useState(true);
  const [page, setPage] = useState(0);
  const [selectedBenefit, setSelectedBenefit] = useState(creative.coupon);

  const loadingRef = useRef(null);
  const isVisible = useIsInViewport(loadingRef);

  const loadBenefits = useCallback(
    async (refresh) => {
      setLoading(true);
      const response = await StandaloneCouponsAPI.getStandaloneCoupons(
        "ACTIVATED",
        null,
        refresh ? 0 : page
      );

      const benefitsPage = response.getData({
        items: [],
        next: { page: -1, limit: 12 },
      });

      let newBenefitsPage;

      if (refresh) {
        newBenefitsPage = [...benefitsPage.items];
      } else {
        newBenefitsPage = [...benefits, ...benefitsPage.items];
      }

      setBenefits(newBenefitsPage);
      setHasNext(benefitsPage.next.page != -1);
      setPage(benefitsPage.next.page != -1 ? page + 1 : page);
      setLoading(false);
    },
    [benefits, page]
  );

  useEffect(() => {
    if (hasNext && isVisible) {
      loadBenefits();
    }
  }, [isVisible, page, hasNext, loadBenefits]);

  const filterCoupons = () => {
    if (!search) return benefits;

    const normalized = search.toLowerCase();

    return benefits.filter((item) => {
      const code = String(item.code).toLowerCase();
      const pin = String(item.pin).toLowerCase();

      const match = code.includes(normalized) || pin.includes(normalized);
      const codePin = (code + pin).toLowerCase().includes(normalized);

      return match || codePin;
    });
  };

  const filteredCoupons = filterCoupons();

  return (
    <>
      <div className="d-flex align-center justify-between mb-20">
        <Label className="mb-0">Cupons ({benefits.length})</Label>
        <a
          href="https://gestor.olga.tech/beneficios"
          target="_blank"
          rel="noreferrer"
        >
          <Button design="two" className="gap-10">
            <i className="far fa-plus" />
            Criar cupom
          </Button>
        </a>
      </div>
      <div className="d-flex align-center gap-10">
        <InputSearch
          placeholder="Buscar por cupom..."
          design="three"
          value={search}
          className="flex-1"
          onChange={(e) => setSearch(e.target.value)}
        />
        <Button design="default-icon-mini" onClick={() => loadBenefits(true)}>
          <i className="far fa-rotate-right" />
        </Button>
      </div>

      <div className={styles.coupons}>
        {filteredCoupons.map((b) => {
          const rules = Benefit.getRules(b);

          const checked = creative?.coupon?.code === b.code;

          return (
            <div
              className={css({
                coupon: true,
                selected: checked,
              })}
              key={b.id}
              onClick={() => {
                if (creative?.coupon?.code === b.code) {
                  onChangeCreative({ coupon: { code: null } });
                } else onChangeCreative({ coupon: { code: b.code } });

                if (selectedBenefit?.id === b.id) {
                  setSelectedBenefit(null);
                } else setSelectedBenefit(b);
              }}
            >
              <Ticket color={checked ? "#6D6DF2" : "#6F767E"} />

              <div className="d-flex flex-column flex-1">
                <div className={styles.header}>
                  <span className={styles.code}>{b.code}</span>
                  <If cond={Environment.id !== 51}>
                    <span className={styles.pin}>{b.pin}</span>
                  </If>
                </div>
                <div className={styles.rules}>
                  {rules.map((rule, index) => (
                    <span className={styles.rule} key={index}>
                      {rule}
                    </span>
                  ))}
                </div>
              </div>

              <Radio family="coupon" value={true} readOnly checked={checked} />
            </div>
          );
        })}

        <If cond={hasNext}>
          <div className={styles.loading}>
            <Loading />
          </div>
          <div ref={loadingRef}></div>
        </If>
      </div>
    </>
  );
}
